import { FormControl, InputLabel, Select } from '@mui/material';
import { styled } from '@mui/material/styles';

const CssFormControl = styled(FormControl)({
  '& label.Mui-focused': {
    color: '#84d8c5',
  },
  '& .MuiInput-underline:after': {
    borderBottomColor: '#84d8c5',
  },
  '& .MuiOutlinedInput-root': {
    '&.Mui-focused fieldset': {
      borderColor: '#84d8c5',
    },
  },
});

export const SelectDropdown = (props) => {
  const handlePrevent = (e) => {
    if (props.viewOnly) e.preventDefault();
  };

  return (
    <CssFormControl
      fullWidth={props.fullWidth}
      required={props.required}
      margin={props.margin}
      sx={props.sx}
      size={props.size}
    >
      <InputLabel>{props.label}</InputLabel>
      <Select
        value={props.value}
        defaultValue={props.defaultValue}
        label={props.label}
        error={props.error}
        onChange={props.onChange}
        disabled={props.viewOnly || props.disabled}
        onMouseDown={handlePrevent} // prevent opening dropdown
        onKeyDown={handlePrevent} // prevent keyboard changes
        style={{ cursor: props.viewOnly ? 'default' : undefined }}
      >
        {props.children}
      </Select>
    </CssFormControl>
  );
};
